import { render, staticRenderFns } from "./teachingClassList.vue?vue&type=template&id=1631e71a"
import script from "./teachingClassList.vue?vue&type=script&lang=js"
export * from "./teachingClassList.vue?vue&type=script&lang=js"
import style0 from "./teachingClassList.vue?vue&type=style&index=0&id=1631e71a&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports